module.exports = __webpack_public_path__ + "img/3939784_0160.b0ba59b4.jpg";